import React from 'react'

import { useAllConversations } from '../../../hocs/gpt/useConversation'
import Loading from '../layout/Loading'
import { useI18N } from '../../../libraries/i18n/hook'
import { AdvisorConversation } from '../../../api/gpt/types'
import * as dateUtils from '../../../libraries/date'
import Translate from '../../../libraries/i18n/Translate'
import NoResults from '../layout/NoResults'

type Props = { onSelect: (conversationId: number) => void }
const ConversationHistory: React.FC<Props> = ({ onSelect }) => {
  const { t } = useI18N()
  const { data: allConversations, isLoading: loadingConversations, mutate } = useAllConversations()
  if(loadingConversations) return <Loading size='fill-container' />
  if(!allConversations) return null

  const handleClickConversation = (conversationId: number) => {
    mutate()
    onSelect(conversationId)
  }

  const groupConversationsByDate = (conversations: AdvisorConversation[]): Array<{ days: string, conversations: AdvisorConversation[] }> => {
    const groupedConversations = conversations.reduce((acc, conversation) => {
      const days = dateUtils.getDaysSinceDate(conversation.updatedAt)
      if(!acc[days]) {
        acc[days] = []
      }
      acc[days].push(conversation)
      return acc
    }, {} as Record<number, AdvisorConversation[]>)

    return Object.entries(groupedConversations).map(([days, conversations]) => ({ days, conversations }))
  }

  return (
    <div className='px-4 lg:px-0'>
      <div className='my-2 border-solid border-b-4 pb-2 border-soft-green lg:border-none'><strong>{t('advisor.historic.title')}</strong></div>
      {allConversations.length === 0 && <NoResults />}
      {groupConversationsByDate(allConversations).map((group) => (
        <div key={`${group.days}-convos`} className='mb-8'>
          <div className='text-2xs lg:text-xs px-3 py-1 border-solid rounded-full border-gray-100 border inline-block'>
            <Translate i18nKey='common.daysAgo' values={{ context: group.days, days: group.days }} />
          </div>
          {group.conversations.map((conversation) => (
            <button key={`convo-${conversation.id}`} className='my-4 text-black text-start hover:text-deep-green font-light text-xs sm:text-sm line-clamp-2' onClick={() => handleClickConversation(conversation.id)}>
              {conversation.messages?.length > 0 ? conversation.messages[conversation.messages.length - 1].content : 'Empty'}
            </button>
          ))}
        </div>
      ))}
    </div>
  )
}

export default ConversationHistory
